import {
  GameLiveConnectionMethod as BaseGameLiveConnectionMethod
} from '@pascal/pascal-core/shared/core/services/liveConnection/types';

export const DemoGameLiveConnectionMethod = Object.assign({
  DoDemoSpin: 'DoDemoSpin',
  DemoCashOut: 'DemoCashout',
  DemoReportState: 'DemoReportState',
  DemoCashOutResult: 'DemoCashoutResult',
  GetDemoInitialState: 'GetDemoInitialState',
  GetDemoInitialStateResult: 'GetDemoInitialStateResult',
  DemoResultReportResult: 'DemoReportStateResult',
  DoDemoSpinResult: 'DoDemoSpinResult',
}, BaseGameLiveConnectionMethod);
